import {
  reactQueryDelete,
  reactQueryPost,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { AttributableType } from "@circle-react/types/PaywallsAffiliates";

export interface CreateAttributionDataType {
  affiliate_id: number | null;
  attributable_id: number;
  attributable_type: AttributableType;
}

export interface DestroyAttributionDataType {
  attributable_id: number;
  attributable_type: AttributableType;
}

const create = (params: CreateAttributionDataType) =>
  reactQueryPost<CreateAttributionDataType, CreateAttributionDataType>(
    internalApi.paywalls.affiliates.attributions.create(),
    params,
  );

const destroy = (params: DestroyAttributionDataType) =>
  reactQueryDelete<undefined, DestroyAttributionDataType>(
    internalApi.paywalls.affiliates.attributions.destroy(),
    params,
  );

export const attributions = {
  create,
  destroy,
};
